import React, { useCallback, useEffect, useState } from 'react';

import confirm from 'components/confirm';
import Snackbar from 'shared/snackbar';
import { deleteShowcaseContact, fetchShowcaseContacts } from './api';
import ShowcaseContactModal from './modal';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

function ShowcaseContactsCompanyIndex() {
  const [show, setShow] = useState(false);
  const [showcaseContacts, setShowcaseContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [flash, setFlash] = useState(null);

  const flashMessage = useCallback((message, type) => {
    setFlash({ message, type });
    setTimeout(() => setFlash(null), 5000);
  }, []);

  const handleDataResponse = useCallback((data) => {
    setShow(true);
    if (Array.isArray(data) && data.length > 0) {
      setShowcaseContacts(data);
    } else {
      setShowcaseContacts([]);
    }
  }, [showcaseContacts]);

  useEffect(() => {
    fetchShowcaseContacts()
      .then(handleDataResponse)
      .catch(() => { /* noop - when the customization is not enabled, /showcase_contacts returns 401 */ });
  }, []);


  if (!show) return null;

  // handleContactAdded is a callback to be called after a contact has already been created on the backend
  // Errors and validation will be handled in the form component
  const handleContactAdded = (contact) => {
    setShowModal(false);
    setShowcaseContacts([...showcaseContacts, contact]);
    flashMessage(`Contact "${contact.firstName} ${contact.lastName}" added!`, 'success');
  };

  const handleDeleteContact = (contact) => {
    const { firstName, lastName, id } = contact;

    confirm(
      `Are you sure you want to delete contact "${firstName} ${lastName}?"`,
      {
        buttonLabel: 'Delete',
        buttonStyle: 'danger',
        title: 'Delete Contact?',
      }
    ).then(() => {
      deleteShowcaseContact(id).then(handleDataResponse).then(() => {
        flashMessage(`Contact "${firstName} ${lastName}" deleted!`, 'danger');
      });
    });
  };

  return (
    <React.Fragment>
      <div className="user-table-wrapper">
        <div className="d-flex justify-content-between align-items-center">
          <h2>Showcase Contacts</h2>
          <button className="btn btn-create" onClick={() => setShowModal(true)}>
            + Add Showcase Contact
          </button>
        </div>
        {showcaseContacts.length === 0 ? (
          <div className="alert alert-info mt-3">
            No showcase contacts found. Add a new contact to get started.
          </div>
        ) : (
          <table className="table table-hover user-table">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Email</th>
                <th>Job Title</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {showcaseContacts.map(contact => (
                <tr key={contact.id}>
                  <td></td>
                  <td>{contact.firstName} {contact.lastName}</td>
                  <td>{contact.email}</td>
                  <td>{contact.jobTitle}</td>
                  <td>
                    <Button bsStyle="link" className="text-danger" onClick={() => handleDeleteContact(contact)}>
                      <FontAwesomeIcon className="text-danger" icon={faTrash} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {flash && (
        <Snackbar
          position="bottom"
          show={true}
          text={flash.message}
          variant={flash.type}
          onClose={() => setFlash(null)}        
        />
      )}
      <ShowcaseContactModal
        show={showModal}
        onAddContact={handleContactAdded}
        onClose={() => setShowModal(false)}
      />
    </React.Fragment>
  );
}

export default ShowcaseContactsCompanyIndex;
